import React from "react";
import {TruckDelivery} from "mdi-material-ui";

export default function Delivery(props) {
    return (
        <TruckDelivery className={props.className} />
    );
};